<template>
  <div style="height: 100vh;" class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <!-- desktop >768px md -->
    <el-row style="max-width:900px" class="full-width container top-spacing">
      <el-col :xs="24" :sm="16" :md="16" :lg="16">
        <div class="flex colum justify-content-center align-items-center">
          <p class="notify-1 fw-cv2 mt-10">
            {{ $t("doNotShareAuthenticationCode") }}
          </p>
          <div class="email-icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="63"
              height="37"
              viewBox="0 0 63 37"
              fill="none"
            >
              <path
                d="M11.4265 32.0822C16.5951 27.5798 21.7637 23.0773 27.0144 18.5024C21.7947 13.9535 16.6061 9.43438 11.4192 4.91335C11.3425 4.93563 11.2658 4.95791 11.1909 4.9802C11.1909 5.86955 11.2056 6.7589 11.1873 7.64825C11.169 8.54131 10.738 9.09832 10.0257 9.20786C9.21665 9.33226 8.46237 8.81982 8.41854 7.99359C8.36375 6.97984 8.32174 5.94381 8.46054 4.94306C8.8733 1.97422 11.1581 0.00985179 14.1387 0.00613843C22.7536 -0.00500168 31.3685 0.00242506 39.9834 0.00242506C45.6578 0.00242506 51.3323 0.000568373 57.0068 0.00242506C60.654 0.00428174 62.9918 2.3697 62.9954 6.07564C63.0009 14.3676 63.0027 22.6614 62.9954 30.9534C62.9918 34.6166 60.6449 36.9969 57.047 36.9969C42.8252 37.0006 28.6052 37.0006 14.3834 36.9969C10.7471 36.9969 8.39114 34.6036 8.38566 30.9199C8.38566 30.4112 8.38018 29.9006 8.38566 29.3919C8.39845 28.393 8.93357 27.7747 9.781 27.7729C10.6266 27.7691 11.1654 28.3707 11.1855 29.3826C11.2019 30.2552 11.1891 31.126 11.1891 31.9987L11.4247 32.0804L11.4265 32.0822ZM13.4447 2.88957C13.7241 3.15136 13.8665 3.29433 14.02 3.42801C20.8414 9.36011 27.661 15.2941 34.4842 21.2225C35.4084 22.0246 36.0074 22.0134 36.948 21.1965C43.7694 15.2644 50.589 9.33041 57.4068 3.39459C57.5565 3.26462 57.6953 3.12165 57.9419 2.88771H13.4447V2.88957ZM13.4319 34.0893H57.9675C52.6309 29.4383 47.4331 24.9061 42.2115 20.3554C40.8856 21.5232 39.6309 22.6651 38.3378 23.7624C36.8676 25.0082 34.9189 25.0992 33.3939 24.0353C33.1875 23.8924 32.9994 23.7216 32.8113 23.5545C31.6095 22.498 30.4115 21.4416 29.1805 20.3573C23.937 24.9303 18.7429 29.4587 13.4319 34.0911V34.0893ZM60.1262 4.78524C54.806 9.42138 49.6156 13.9424 44.3831 18.5024C49.6411 23.0829 54.8207 27.5946 60.1262 32.2159V4.78524Z"
                :fill="bg.c_button_main"
              />
              <path
                d="M7.64414 23.4952C5.61689 23.4952 3.59147 23.5063 1.56422 23.4896C0.490325 23.4803 -0.154377 22.7284 0.0319111 21.7573C0.165235 21.0592 0.73323 20.6322 1.61718 20.6266C3.37048 20.6117 5.12378 20.621 6.87708 20.621C9.15454 20.621 11.432 20.6155 13.7076 20.6247C14.6555 20.6285 15.2582 21.0908 15.3587 21.8446C15.4865 22.7841 14.84 23.484 13.7916 23.4915C11.7425 23.5063 9.69331 23.4952 7.64414 23.4952Z"
                :fill="bg.c_button_main"
              />
              <path
                d="M9.7536 13.5077C11.0741 13.5077 12.3963 13.5003 13.7168 13.5096C14.7468 13.517 15.3733 14.0684 15.3715 14.9429C15.3715 15.8156 14.7505 16.3726 13.7131 16.3781C11.0941 16.3893 8.47515 16.3893 5.85434 16.3781C4.83158 16.3744 4.18323 15.7951 4.18323 14.9411C4.18323 14.0888 4.84254 13.517 5.85617 13.5114C7.1547 13.5021 8.45324 13.5096 9.75177 13.5096L9.7536 13.5077Z"
                :fill="bg.c_button_main"
              />
            </svg>
            <!-- <img :src="icons.EmailIcon" alt="" /> -->
          </div>
          <div class="">
            <p class="text-align-center  m-0 c-medium-text c-black-text">
              {{ $t("authenticationCodeSentToPhoneNumber") }}
            </p>
            <p class="text-align-center m-0 c-bold-text c-black-text ">
              (+84) {{ decodeToken().phone }}
            </p>
            <p class="text-align-center   m-0 notify-1">
              {{ $t("enterAuthenticationCodeBelow") }}
            </p>
          </div>
          <div class="text-center otp-container">
            <v-otp-input
              class="otp-verify"
              pattern="\d*"
              @finish="onFinish"
              length="6"
              plain
              variant="underlined"
              type="number"
            ></v-otp-input>
          </div>
          <div class="px-15">
            <p
              v-if="totalSeconds > 0"
              class="text-align-center notify-2 c-medium-text"
            >
              {{ $t("pleaseWait") }}
              <span class="c-text-main c-rather-text">
                {{ totalSeconds }} {{ $t("seconds") }}</span
              >
              {{ $t("toResendNewCode") }} <br />
              {{ $t("noteCheckMessage") }}
            </p>
            <p v-else class="text-align-center notify-2 c-medium-text">
              {{ $t("authenticationCodeExpired") }}
              <span @click="getOtp" class="c-text-main c-rather-text">
                {{ $t("resend") }}</span
              >
              {{ $t("toResendCode") }} {{ $t("noteCheckMessageAgain") }}
            </p>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import EmailIcon from "@/assets/img/svg/email-icon.svg";
import { decodeToken, getBackGround } from "../../../../utils/wapAuth";

export default {
  components: {
    MainNavBarWapV2
  },
  bodyClass: "home-page",
  props: {
    timeData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  watch: {},
  created() {
    this.totalSeconds = 125;
    this.intervalId = setInterval(this.updateTime, 1000);
    console.log("timeData_________", this.timeData);
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  data() {
    return {
      totalSeconds: -1,
      otp: "",
      isShowContent: false,
      more: "Xem thêm...",
      rules: {},
      isActive: 0,
      infoHeader: {
        title: this.$t("wap.text119"),
        isShowHomeIcon: false
      },
      bg: getBackGround(),

      icons: {
        EmailIcon
      }
    };
  },

  watch: {},
  methods: {
    getOtp() {
      this.$emit("get-otp", { reload: true });
      this.totalSeconds = 125;
      this.intervalId = setInterval(this.updateTime, 1000);
      //   const body = { phone: decodeToken().phone };
      //   TeeTimeResource.getOTPOrderBookingFast(body).then(res => {
      //     if (res.error_code === 0) {
      //       this.totalSeconds = res.data.time;
      //       this.otp = res.data.code;
      //       this.intervalId = setInterval(this.updateTime, 1000);
      //     } else {
      //       this.$message.error(res.error_msg);
      //     }
      //   });
    },

    updateTime() {
      if (this.totalSeconds > 0) {
        this.totalSeconds--;
      } else {
        clearInterval(this.intervalId);
      }
    },
    handleFilter(val) {
      this.isActive = val;
    },
    async onFinish(otp) {
      if (this.totalSeconds < 1) {
        this.$message.error(
          "OTP đã hết hạn, Vui lòng Click gửi lại để gửi lại mã."
        );
        return;
      }
      this.$emit("send-otp", otp);
    },
    decodeToken
  }
};
</script>
<style lang="scss">
.otp-container {
  .otp-verify.theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    background: #f5f5f5;
    color: rgba(0, 0, 0, 0.87);
  }
}
.el-popover {
  border-radius: 10px !important;
}
</style>

<style scoped>
.notify-2 {
  color: #7f7f7f;
}
.otp-container {
  margin: 30px 20px;
}
.email-icon-container {
  margin: 30px 0;
}
.notify-1 {
  text-align: center;
  color: #999999;
  font-size: 14px;
}
.px-15 {
  padding: 0 15px;
}

.divider-view {
  height: 10px !important;
  width: 100%;
  background-color: #e3e3e3;
  margin: 30px 0;
}

.top-spacing {
  padding-top: 100px;
}

.divider-view {
  height: 1px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ececec;
}

.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mr-10 {
  margin-right: 10px;
}

.ml-10 {
  margin-left: 10px;
}
.ml-20 {
  margin-left: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-20 {
  margin-right: 20px;
}
.ml-4 {
  margin-left: 4px;
}
.flex-grow {
  flex-grow: 1;
}

.pt-12 {
  padding-top: 12px;
}
.pb-0 {
  margin-bottom: 0px;
}
.pb-80 {
  padding-bottom: 80px;
}
.mt-36 {
  margin-top: 36px;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .top-spacing {
    padding-top: 60px !important;
  }
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;

.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 769px) and (max-width: 980px) {
  .top-spacing {
    padding-top: 60px !important;
  }
}
</style>
